export default __webpack_public_path__ + "static/media/Ellipse 13.347e7899.png";